import * as z from 'zod';

// Raw browser values are validated, never trimmed or repaired.
const value = z.string().min(1).max(512);
const capturedAt = z.iso.datetime({ offset: true });

const touch = z.strictObject({
  touchId: z.uuid(),
  capturedAt,
  landingPagePath: value.regex(/^\/[^?#]*$/).optional(),
  referrerDomain: value
    .regex(/^(?=.{1,253}$)([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,63}$/)
    // A VRPlatform hostname is never an external referrer.
    .refine((domain) => !/(^|\.)vrplatform\.app$/.test(domain))
    .optional(),
  utmSource: value.optional(),
  utmMedium: value.optional(),
  utmCampaign: value.optional(),
  utmTerm: value.optional(),
  utmContent: value.optional(),
  gclid: value.optional(),
  gbraid: value.optional(),
  wbraid: value.optional(),
  mixpanelDeviceId: value.optional(),
});

const grant = z.enum(['granted', 'denied']);

export const marketingAttributionV1 = z.strictObject({
  version: z.literal(1),
  firstTouch: touch.optional(),
  conversionTouch: touch.optional(),
  consent: z.strictObject({
    marketingStorage: z.literal('granted'),
    adUserData: grant,
    adPersonalization: grant,
    policyVersion: value,
    capturedAt,
  }),
});

export type MarketingAttributionV1 = z.infer<typeof marketingAttributionV1>;
export type MarketingTouchV1 = NonNullable<
  MarketingAttributionV1['firstTouch']
>;
export type MarketingConsentV1 = MarketingAttributionV1['consent'];
